/* o’po’stro’phe: the ad that brought a buyer, kept on the order (funnel audit 2026-10-29 #9).
   A landing whose link carries utm_* values keeps them, first touch (an earlier landing in the last 7 days wins), in
   localStorage and this tab's sessionStorage, and writes them into the cart as cart attributes (POST /cart/update.js):
   right after an add to cart succeeds (any add on any page: the home sheet, the line-up pickers, the theme's own forms),
   on a page load whose cart already has items but names no ad (a plain form post, a later tab), and again at the check-out
   click if the cart still lacks them (hidden fields on the cart form, which Shopify applies before it opens checkout; a
   keepalive request for the other check-out buttons). Cart attributes become the order's note_attributes ("Additional
   details"), so each order names its ad (utm_content=dog-v17), also when the buyer finishes the same cart in Safari after
   the Instagram browser.
   Written: utm_source, utm_medium, utm_campaign, utm_content, utm_term (those the link had), landed_at (the landing's UTC
   time), landing_page (its path), click_id (fbclid | ttclid | gclid when the link carried one: the name, never the value).
   Never written over: a cart that already names an ad keeps it (layout/theme.liquid passes data-has).
   Consent, exactly as the theme's tallies and assets/o-visit.js: nothing is stored or written unless Shopify's Customer
   Privacy API answers analyticsProcessingAllowed() === true (o-visit.js asks Shopify; this waits on its answer).
   Never delays or blocks the add or the check-out, every failure is silent, and a visit without utm values does nothing.
   QA: window.oUtm.state(). */
(function () {
  'use strict';
  if (window.oUtm) return;
  var K = 'o-utm', TTL = 7 * 864e5, UTM = ['source', 'medium', 'campaign', 'content', 'term'];
  var OK_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'landed_at', 'landing_page', 'click_id'];
  var me = document.currentScript;
  var carted = !!(me && +(me.getAttribute('data-n') || 0) > 0), written = !!(me && me.getAttribute('data-has') === '1');
  var started = false, busy = false, touch = null, log = [];

  function allowed() { try { var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true; } catch (err) {} return false; }
  function clean(s, n) { return String(s == null ? '' : s).replace(/[\u0000-\u001f\u007f<>]/g, '').trim().slice(0, n || 100); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  // this landing's values, read before anything can rewrite the address (kept in memory until consent)
  var fresh = (function () {
    try {
      var sp = new URLSearchParams(location.search), v = {}, any = false;
      UTM.forEach(function (k) { var x = clean(sp.get('utm_' + k)); if (x) { v['utm_' + k] = x; any = true; } });
      if (!any) return null;
      v.landed_at = new Date().toISOString().replace(/\.\d+Z$/, 'Z');
      v.landing_page = clean(location.pathname) || '/';
      ['fbclid', 'ttclid', 'gclid'].some(function (c) { if (sp.get(c)) { v.click_id = c; return true; } return false; });
      return { v: v, t: Date.now() };
    } catch (err) { return null; }
  })();

  function read(store) {
    try {
      var s = window[store], r = JSON.parse(s.getItem(K) || 'null');
      if (!r || typeof r !== 'object' || !r.v || typeof r.v !== 'object' || !(+r.t > 0)) return null;
      if (Date.now() - r.t >= TTL || r.t > Date.now() + 864e5) { s.removeItem(K); return null; } // 7 days, then gone
      var v = {}, any = false;
      OK_KEYS.forEach(function (k) { if (typeof r.v[k] === 'string' && clean(r.v[k])) { v[k] = clean(r.v[k]); if (k.indexOf('utm_') === 0) any = true; } });
      return any ? { v: v, t: +r.t } : null;
    } catch (err) { return null; }
  }
  function keep(r) { ['localStorage', 'sessionStorage'].forEach(function (s) { try { window[s].setItem(K, JSON.stringify(r)); } catch (err) {} }); }

  function start() {
    if (started || !allowed()) return;
    started = true;
    var had = read('localStorage') || read('sessionStorage');
    touch = had || fresh;
    if (touch) keep(touch);
    if (carted) toCart('load');
  }

  // POST /cart/update.js with the attributes, once per page (busy + written); a failure stays silent and may retry later
  function toCart(why, keepalive) {
    if (written || busy || !touch || !window.fetch || !allowed()) return;
    busy = true;
    var rec = { why: why, at: Date.now() };
    log.push(rec);
    try {
      fetch(root() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: !!keepalive, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: touch.v }) })
        .then(function (r) { if (!r.ok) throw new Error('update ' + r.status); return r.json(); })
        .then(function (c) { busy = false; rec.ok = !!(c && c.attributes && c.attributes.landed_at); if (rec.ok) written = true; })
        .catch(function () { busy = false; rec.ok = false; });
    } catch (err) { busy = false; rec.ok = false; }
  }

  // an add to cart finished (any page, any script): the request itself, plus the theme's own events as a second signal
  function added() { carted = true; if (started) setTimeout(function () { toCart('add'); }, 0); }
  try {
    if (window.PerformanceObserver) {
      var po = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.initiatorType !== 'fetch' && e.initiatorType !== 'xmlhttprequest') return;
          if (e.responseStatus && e.responseStatus >= 400) return; // Chrome says when the add failed; others: harmless
          var p = ''; try { p = new URL(e.name, location.href).pathname; } catch (err) { return; }
          if (/\/cart\/add(\.js|\.json)?$/.test(p)) added();
        });
      });
      try { po.observe({ type: 'resource' }); } catch (err) { po.observe({ entryTypes: ['resource'] }); }
    }
  } catch (err) {}
  ['cart:refresh', 'shopify:cart:lines-update'].forEach(function (n) { document.addEventListener(n, added, true); });

  // check-out pressed while the cart still names no ad: the cart form carries the attributes in its own post (Shopify
  // applies them before it redirects to checkout); other check-out buttons get a keepalive request. Nothing waits for either.
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target && ev.target.closest ? ev.target : null; if (!t || written || !started || !touch || !allowed()) return;
      var el = t.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, shopify-buy-it-now-button');
      if (!el) return;
      var f = el.form || null;
      if (f && /\/cart\/?(\?|$)/.test(f.getAttribute('action') || '')) {
        [].forEach.call(f.querySelectorAll('input[data-o-utm]'), function (i) { i.remove(); });
        Object.keys(touch.v).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'attributes[' + k + ']'; i.value = touch.v[k]; i.setAttribute('data-o-utm', ''); f.appendChild(i); });
        log.push({ why: 'checkout-form', at: Date.now(), ok: true });
      } else toCart('checkout', true);
    } catch (err) {}
  }, true);

  // consent: o-visit.js already asks Shopify and shares its answer; without it, ask the same way (up to 20 s)
  function ask() {
    if (window.oVisit && typeof window.oVisit.ready === 'function') { window.oVisit.ready(function (ok) { if (ok) start(); }); return; }
    var tries = 0;
    (function poll() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return start();
      if (++tries === 1) { try { if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (err) {} }
      if (tries < 160) setTimeout(poll, 125);
    })();
  }
  document.addEventListener('visitorConsentCollected', function () { start(); }); // a later yes at the banner (EU/UK)

  window.oUtm = {
    state: function () { return { started: started, carted: carted, written: written, busy: busy, touch: touch, fresh: fresh, sent: log.slice() }; },
    toCart: toCart,
  };
  ask();
})();
